import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import styles from './inspirecommila_pagina.module.scss';
import essencia from './src/essencia.jpeg';

const INSTAGRAM_URL = 'https://www.instagram.com/euessenciadolar_?igsi=MWttMnFianRhMHZjOA==';

const Essencia_inspirecommila: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.page}>
            <div className={styles.sheet}>
                <div className={styles.header}>
                    <Link to="/inspirecommila" className={styles.back} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                    <h1>Presencial</h1>
                </div>

                <figure className={`${styles.hero} ${styles.pano}`}>
                    <img src={essencia} alt="Mila em um terraço, com um livro aberto" />
                </figure>

                <div className={styles.corpo}>
                    <p className={styles.eyebrow}>Essência do Lar</p>
                    <h2 className={styles.titulo}>Encontro presencial para mulheres</h2>
                    <p className={styles.lead}>
                        Para quem deseja fortalecer identidade, fé e compreender o próprio papel na construção de um
                        lar firmado em Deus.
                    </p>
                    <div className={styles.texto}>
                        <p>
                            Nasceu de um princípio: edificar a casa começa muito antes da organização dos cômodos.
                            Começa dentro da mulher. É um tempo fora da correria: Palavra, comunhão, reflexão, cura e
                            presença.
                        </p>
                        <p>
                            Falamos da mulher por inteiro: a que precisa cuidar de si e também influencia os ambientes
                            de que faz parte. Cada edição é preparada com conversas profundas, experiências e
                            conexões. Vagas limitadas.
                        </p>
                    </div>
                    <p className={styles.citacao}>“A mulher sábia edifica a sua casa.” (Provérbios 14:1)</p>
                    <a
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.cta}
                    >
                        Ver próximas edições
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Essencia_inspirecommila;
